module.exports = __webpack_public_path__ + "static/img/menage2.6d9dddc3.jpg";